import { DateService } from "@standard/services";
import React from "react";

export default ({ value }) => {
  if (!value) return;

  return (
    <div className="alert alert-danger">
      <h4 className="alert-hwading">Reject</h4>
      <p>{value.message}</p>
      {value.assetsPreview && (
        <ul className="list-unstyled">
          {value.assetsPreview.map((item) => (
            <li>
              <i className="fa fa-file mr-2"></i>
              <a href={`${item.url}`} target="_blank">
                {item.name}
              </a>
            </li>
          ))}
        </ul>
      )}
      <hr />
      <p className="mb-0">
        <strong>By</strong> {value.name} <strong>At</strong> {value.createdAt}
      </p>
    </div>
  );
};
